import { useAsyncEffect } from '@xylabs/sdk-react'
import BigNumber from 'bn.js'
import { PropsWithChildren, useContext, useState } from 'react'

import { parseBigNumberOptional } from '../../../parseBigNumber'
import { EthersContext } from '../../Ethers'
import { CurrencyContext } from '../Context'
import { CurrencyBalanceContext } from './Context'

interface Props {
  enabled?: boolean
}

export const CurrencyBalanceLoader: React.FC<PropsWithChildren<Props>> = (props) => {
  const { children } = props
  const enabled = true
  const { erc20 } = useContext(CurrencyContext)
  const { currentNetwork, localAddress } = useContext(EthersContext)
  const [minterAllowance, setMinterAllowance] = useState<BigNumber>()
  const [geotokensAllowance, setGeotokensAllowance] = useState<BigNumber>()
  const [balance, setBalance] = useState<BigNumber>()
  const [refreshCount, setRefreshCount] = useState(0)

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      if (enabled) {
        let balance = undefined
        let minterAllowance = undefined
        let geotokensAllowance = undefined
        const minter = currentNetwork?.addresses.minter
        const geotokens = currentNetwork?.addresses.geotokens
        if (erc20 && localAddress) {
          balance = parseBigNumberOptional(await erc20?.getBalance(localAddress))
        }
        if (erc20 && minter && localAddress) {
          minterAllowance = parseBigNumberOptional(await erc20?.getAllowance(minter, localAddress))
        }
        if (erc20 && geotokens && localAddress) {
          geotokensAllowance = parseBigNumberOptional(await erc20?.getAllowance(geotokens, localAddress))
        }
        if (!isMounted()) return
        setBalance(balance)
        setMinterAllowance(minterAllowance)
        setGeotokensAllowance(geotokensAllowance)
      }
    },
    [erc20, localAddress, currentNetwork, refreshCount, enabled],
  )

  const refresh = () => {
    setRefreshCount(refreshCount + 1)
  }

  return (
    <CurrencyBalanceContext.Provider value={{ balance, geotokensAllowance, minterAllowance, refresh }}>{children}</CurrencyBalanceContext.Provider>
  )
}
